const BASE_URL = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'development' ? 'http://localhost:5000/api' : '/api');

const getHeaders = (token) => ({
  'Content-Type': 'application/json',
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

// ── Auth ──────────────────────────────────────────────
export const registerUser = async (data) => {
  const res = await fetch(`${BASE_URL}/auth/register`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Registration failed');
  return json;
};

export const loginUser = async (email, password) => {
  const res = await fetch(`${BASE_URL}/auth/login`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ email, password }),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Login failed');
  return json;
};

export const adminLogin = async (username, password) => {
  const res = await fetch(`${BASE_URL}/auth/admin-login`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ username, password }),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Admin login failed');
  return json;
};

// ── Applications ──────────────────────────────────────
export const submitApplication = async (formData, token = null) => {
  const res = await fetch(`${BASE_URL}/applications`, {
    method: 'POST',
    headers: getHeaders(token),
    body: JSON.stringify(formData),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Submission failed');
  return json;
};

export const getMyApplications = async (token) => {
  const res = await fetch(`${BASE_URL}/my-applications`, {
    headers: getHeaders(token),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Failed to fetch applications');
  return json;
};

// ── Admin ──────────────────────────────────────────────
export const getAllApplications = async (token) => {
  const res = await fetch(`${BASE_URL}/applications`, {
    headers: getHeaders(token),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Failed to fetch applications');
  return json;
};

export const getFilteredApplications = async (token, customerType, loanType) => {
  const params = new URLSearchParams();
  if (customerType) params.append('customerType', customerType);
  if (loanType) params.append('loanType', loanType);
  const res = await fetch(`${BASE_URL}/applications/filter?${params}`, {
    headers: getHeaders(token),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Failed to filter applications');
  return json;
};

export const updateApplicationStatus = async (token, id, status, statusMessage) => {
  const res = await fetch(`${BASE_URL}/applications/${id}/status`, {
    method: 'PUT',
    headers: getHeaders(token),
    body: JSON.stringify({ status, statusMessage }),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Failed to update status');
  return json;
};

export const deleteApplication = async (token, id) => {
  const res = await fetch(`${BASE_URL}/applications/${id}`, {
    method: 'DELETE',
    headers: getHeaders(token),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Failed to delete application');
  return json;
};
